// Begin action types
export const REFRESH_NAVIGATION = 'REFRESH_NAVIGATION'
// End action types

export const refreshNavigation = () => ({
  type: REFRESH_NAVIGATION
});